const staggerElements = () => {
  const stagger = document.querySelectorAll('.js-stagger-item');
  if(stagger) {
    stagger.forEach(itm => {
      const item = itm.innerText;
      const itemSplit = item.split('');
      itm.innerHTML = '';
      itemSplit.forEach(el => {
        itm.innerHTML += `<span class="js-stagger-char">${el}</span>`
      })
    })
    setTimeout(() => {
      const staggerChar = '.js-stagger-char';
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.js-stagger-trigger',
          start: "top-=50vh center",
          end: "bottom bottom",
          scrub: 1
        }
      });    
      tl.fromTo(
        staggerChar,
      { opacity: 0, y: 50 },
      {
        opacity: 1, 
        duration: .5,
        y: 0,
        ease: "linear",
        stagger: 0.2,
      });
    }, 200);
  }
}

document.addEventListener('DOMContentLoaded', () => staggerElements());
window.addEventListener('resize', () => {
  staggerElements()
});

ScrollTrigger.addEventListener("refresh", () => {
  staggerElements();
});